import React from 'react';

import {useSelector} from 'react-redux';

import {HTMLDiffDiv} from 'app/utils/showdiff';

import {StepLaneStructure} from './StepLane';

import {LaneSerializedType} from 'sweet-types';

interface Props {
  laneDiff: {new: string | null; old: string | null};
}

export function StepLaneDiff({laneDiff}: Props): JSX.Element | null {
  const {old: oldLaneId, new: newLaneId} = laneDiff;

  const oldLane: LaneSerializedType | null = useSelector((state) =>
    oldLaneId != null ? state.lanes.byId[oldLaneId] : null
  );

  const newLane: LaneSerializedType | null = useSelector((state) =>
    newLaneId != null ? state.lanes.byId[newLaneId] : null
  );

  return (
    <>
      <HTMLDiffDiv>
        {oldLaneId == null && newLaneId != null ? (
          <ins>
            <StepLaneStructure>
              {newLane != null ? newLane.name : 'Untitled Lane'}
            </StepLaneStructure>
          </ins>
        ) : oldLaneId != null && newLaneId == null ? (
          <del>
            <StepLaneStructure>
              {oldLane != null ? oldLane.name : 'Untitled Lane'}
            </StepLaneStructure>
          </del>
        ) : oldLaneId != null && newLaneId != null ? (
          <div>
            <StepLaneStructure>
              <del>{oldLane != null ? oldLane.name : 'Untitled Lane'}</del>{' '}
              <ins>{newLane != null ? newLane.name : 'Untitled Lane'}</ins>
            </StepLaneStructure>
          </div>
        ) : null}
      </HTMLDiffDiv>
    </>
  );
}
